import React from 'react';
import Icon, { IconName } from './Icon';

interface EmptyStateProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: IconName;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, icon = 'book', action }) => (
  <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
    <span className="mb-1 flex h-12 w-12 items-center justify-center rounded-full bg-school-primary-soft text-school-primary">
      <Icon name={icon} className="h-6 w-6" />
    </span>
    <p className="font-semibold text-school-ink">{title}</p>
    {description && <p className="max-w-sm text-sm text-school-muted">{description}</p>}
    {action && <div className="mt-3">{action}</div>}
  </div>
);

export default EmptyState;
